export enum LangEnum {
  RU = "ru",
  KZ = "kz",
  EN = "en",
}

export interface ILangInfo {
  shortName: string;
  lang: LangEnum;
}

export interface ITranslationModel {
  ru: string;
  kz?: string;
  en?: string;
}
